import axios from 'axios';
import EventBus from '@/utils/eventBus';
import utils from '@/utils/index';

const axiosService = axios.create({
  headers: {
    'Content-Type': 'application/json'
  }
});

const apiURL = process.env.NODE_ENV === 'production' ? '/api/' : process.env.VUE_APP_API_URL;
const createHeaders = (jwt) => ({ headers: { Authorization: `Bearer ${jwt}` } });

async function getToken() {
  if (utils.bypassAuth()) return '';
  const token = window.localStorage.getItem('app_token');
  if (!token) {
    EventBus.$emit('authError', 401);
    throw Error();
  } else return token;
}

async function get(endpoint) {
  const url = apiURL + endpoint;
  const token = await getToken();
  try {
    const response = await axiosService.get(url, createHeaders(token));
    return response.data;
  } catch (err) {
    if (err.response.status === 401 || err.response.status === 403) {
      EventBus.$emit('authError', err.response.status);
    }
    throw err;
  }
}

async function post(endpoint, body) {
  const url = apiURL + endpoint;
  const token = await getToken();
  try {
    const response = await axiosService.post(url, body, createHeaders(token));
    return response.data;
  } catch (err) {
    if (err.response.status === 401 || err.response.status === 403) {
      EventBus.$emit('authError', err.response.status);
    } else if (err.response.status === 400 && err.response.data.name.length > 0) {
      const messages = err.response.data.name.join(', ');
      throw messages;
    }
    throw err;
  }
}

async function patch(endpoint, body) { // partial object update
  const url = apiURL + endpoint;
  const token = await getToken();
  try {
    const response = await axiosService.patch(url, body, createHeaders(token));
    return response.data;
  } catch (err) {
    if (err.response.status === 401 || err.response.status === 403) {
      EventBus.$emit('authError', err.response.status);
    } else if (err.response.status === 400 && err.response.data.name.length > 0) {
      const messages = err.response.data.name.join(', ');
      throw messages;
    }
    throw err;
  }
}

async function put(endpoint, body) { // full object update
  const url = apiURL + endpoint;
  const token = await getToken();
  try {
    const response = await axiosService.put(url, body, createHeaders(token));
    return response.data;
  } catch (err) {
    if (err.response.status === 401 || err.response.status === 403) {
      EventBus.$emit('authError', err.response.status);
    } else if (err.response.status === 400 && err.response.data.name.length > 0) {
      const messages = err.response.data.name.join(', ');
      throw messages;
    }
    throw err;
  }
}

export default {
  get,
  post,
  patch,
  put
};
